require("./artwork.scss");
(function ($) {

    let index = 0;

    function loadImage(id,sold) {

        let zoom = $('section#artwork > .zoom');

        $.ajax({
            url: get_image_auto.url + "/" + id,
            type: "GET",
            dataType: "json",
            beforeSend: function () {

                // console.log('loading...')
                zoom.html("<div class='loading'><?xml version='1.0' encoding='UTF-8' standalone='no'?><svg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.0' width='64px' height='64px' viewBox='0 0 128 128' xml:space='preserve'><path fill='#ffffff' d='M64.4 16a49 49 0 0 0-50 48 51 51 0 0 0 50 52.2 53 53 0 0 0 54-52c-.7-48-45-55.7-45-55.7s45.3 3.8 49 55.6c.8 32-24.8 59.5-58 60.2-33 .8-61.4-25.7-62-60C1.3 29.8 28.8.6 64.3 0c0 0 8.5 0 8.7 8.4 0 8-8.6 7.6-8.6 7.6z'><animateTransform attributeName='transform' type='rotate' from='0 64 64' to='360 64 64' dur='1600ms' repeatCount='indefinite'></animateTransform></path></svg></div>");


            },
            success: function (res) {

                if (res) {
                    zoom.html("<a class='prev'></a>" + res + "<a class='next'></a>");
                    let img = zoom.find('img');
                    if(sold){
                        zoom.find('picture').addClass('sold');
                    }

                    img.on('load', function () {
                        setTimeout(function () {
                            img.addClass('show');
                        }, 100);
                    });

                    
                    $('section#artwork > .zoom > .next').click(function () {

                        if (index == $('section#artwork > .gallery > figure').length - 1) {
                            index = 0;
                        } else {
                            index++;
                        }

                        let imgArray = $('section#artwork > .gallery > figure');

                        let id = $(imgArray[index]).find('img').attr('class').split("wp-image-")[1];

                        loadImage(id,$(imgArray[index]).hasClass('sold'));

                        // console.log($(imgArray[index]).hasClass('sold'));
                        
                    })

                    $('section#artwork > .zoom > .prev').click(function () {

                        if (index == 0) {
                            index = $('section#artwork > .gallery > figure').length - 1;
                        }else{
                            index--;
                        }

                        let imgArray = $('section#artwork > .gallery > figure');

                        let id = $(imgArray[index]).find('img').attr('class').split("wp-image-")[1];

                        loadImage(id,$(imgArray[index]).hasClass('sold'));
                        
                    })

                }
            }
        })
    }

    $(document).ready(function () {

        let img = $('section#artwork > .gallery > figure:nth-child(1) > img');
        let id = img.attr('class').split("wp-image-")[1];
        let imgArray = $('section#artwork > .gallery > figure');


        loadImage(id,$(imgArray[index]).hasClass('sold'));

    })

})(jQuery)